export enum FormTemplateTypeEnum {
    LifeInsurance = 1,
    MortgageProtection = 2,
    IncomeProtection = 3,
    SeriousIllnessProtection = 4,
    Mortgages = 5,
    ExecutiveIncomeProtection = 6,
    FinancialPlanning = 7,
    SavingAndInvestments = 8,
    HealthInsurance = 9,
    HealthQuestionnaire = 10,
    HealthQuestionnaireProvider = 11,
    FactFind = 12,
    StatementOfSuitability = 13,
    Pensions = 14
}